import { useEffect, useReducer, Reducer } from 'react';
import { State } from 'utils/store/localItemsStore/types';
import { reducer } from 'utils/store/localItemsStore';
import { error, start, success } from 'utils/store/localItemsStore/actions';
import { AxiosPromise } from 'axios';
import { Nullable } from 'utils/types';

type APIWrapper<T> = {
  runRequest: () => AxiosPromise<T>;
};

type ReducerType<T> = Reducer<State<Nullable<T>>, any>;

const useWrapperFunc = function<DataType = any>(apiWrapper: APIWrapper<DataType>) {
  const [state, dispatch] = useReducer<ReducerType<DataType>>(reducer, {
    data: null,
    pending: false,
    error: '',
    axiosError: null,
    loaded: false,
  });

  useEffect(() => {
    let shouldCancel = false;

    dispatch(start());

    apiWrapper
      .runRequest()
      .then(({ data }) => {
        if (!shouldCancel) {
          dispatch(success(data));
        }
      })
      .catch((err) => {
        if (!shouldCancel) {
          dispatch(error(err.response, err));
        }
      });

    return () => {
      shouldCancel = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state;
};

export default useWrapperFunc;
